import PropTypes from "prop-types";
import React, { Component } from "react";
import {
  SendOutlined as SendOutlinedIcon,
  Clear as ClearIcon,
} from "@material-ui/icons";
import { Urgent as UrgentButton } from "./common/Buttons";
import {
  InputBase,
  IconButton
} from "@material-ui/core";

class UserInput extends Component {
  constructor() {
    super();
    this.state = {
      value: "",
      textCount:0,
      isUrgent: false
    };
  }

  componentDidUpdate(prevProps) {
    if (prevProps.driverInfo.name !== this.props.driverInfo.name) {
      this.setState({
        value: "",
        textCount: 0,
        isUrgent: false,
      });
    }
    if (Object.keys(this.props.selectedMsg).length > 0) {
      this.setUserInputFocus();
    }
  }

  handleKeyDown = (event) => {
    // on enter key submit message
    if (event.keyCode === 13 && !event.shiftKey) {
      return this.submitText(event);
    }
  };
  onChangeMessage = (event) => {
    this.setState({
      value: event.target.value,
      textCount: event.target.value.length,
    });
  };

  submitText = (event) => {
    event.preventDefault();
    const text = this.state.value;
    if (text && text.length > 0) {
      this.props.onSubmit({message:text, isUrgent: this.state.isUrgent});
      this.setState({
        value: "",
        textCount: 0,
        isUrgent: false,
      });
    }
  };

  toggleUrgent = () => {
    this.setState(state => ({
      isUrgent: !state.isUrgent
    }))
  }

  setUserInputFocus = () => {
    this.userInputRef.focus();
  }

  render() {
    const { classes } = this.props;
    const isChatWindowEnabled = this.state.value.length;
    const selectedMsgLength = Object.keys(this.props.selectedMsg).length;
    return (
      <>
        <div className={classes.textNumberCount}>
          {this.state.textCount}/300
        </div>
        {selectedMsgLength > 0 && (
          <div className={`${classes.replyDiv} customScroll`}>
            <div className={classes.replyTextMsg}>
              {this.props.selectedMsg.message}
            </div>
            <ClearIcon
              className={classes.clearIcon}
              onClick={this.props.clearReply}
            ></ClearIcon>
          </div>
        )}
        <div component="form" className={classes.scUserInput}>
          {this.state.isUrgent ? <div className={classes.urgentText}>Urgent!</div> : null}
          <InputBase
            tabIndex="0"
            inputRef={(el) => (this.userInputRef = el)}
            autoFocus
            value={this.state.value}
            onKeyDown={this.handleKeyDown}
            placeholder="Write a reply..."
            multiline
            onChange={this.onChangeMessage}
            classes= {{
              inputMultiline: `${classes.textArea} customScroll`
            }}
            inputProps={{
              maxLength: 300,
            }}
            onSubmit={this.submitText}
            className={`${classes.scUserInputText} ${classes.muiInputBaseInput}`}
            startAdornment={
              <UrgentButton
                onClick={this.toggleUrgent}
                isMarkedAsUrgent={this.state.isUrgent}
              />
            }
            endAdornment={
              <IconButton
                disabled={!isChatWindowEnabled}
                className={classes.scUserInputButtons}
                type="button"
                onClick={this.submitText}
                classes={{root: isChatWindowEnabled ? "" : classes.chatSendButton}}
              >
                <SendOutlinedIcon className={classes.sendChatMessage} />
              </IconButton>
            }
          />
        </div>
      </>
    );
  }
}

UserInput.propTypes = {
  onSubmit: PropTypes.func.isRequired,
};

export default UserInput;
